import { useState, useEffect } from 'react';
import { getCaseStudies } from '../api';
import CaseStudyCard from '../components/shared/CaseStudyCard';

export default function CaseStudiesPage() {
  const [studies, setStudies] = useState([]);

  useEffect(() => {
    getCaseStudies().then(setStudies).catch(() => {});
  }, []);

  return (
    <div className="pt-28 pb-20">
      <div className="container mx-auto px-4 md:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h1 className="text-4xl md:text-5xl font-bold mb-4">Case Studies</h1>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Real results for real businesses. See how we've helped our clients grow revenue and build products that convert.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {studies.map(s => <CaseStudyCard key={s.id} study={s} />)}
        </div>
        {studies.length === 0 && (
          <p className="text-center text-gray-500 py-12">No case studies published yet. Check back soon!</p>
        )}
      </div>
    </div>
  );
}
